import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Header from './Header';

function About() {
    const navigate = useNavigate();

    return (
        <div className="about-page">
            <Header />

            {/* Hero Section */}
            <section className="about-hero">
                <Container>
                    <Row className="justify-content-center text-center">
                        <Col lg={8}>
                            <h1 className="about-title">About Press Forward Mail</h1>
                            <p className="about-subtitle">
                                Helping missionaries stay connected with their supporters through
                                seamless email forwarding.
                            </p>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* Content Section */}
            <section className="about-content">
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={10}>
                            <div className="content-card">
                                <div className="mission-statement">
                                    <h2>Our Mission</h2>
                                    <p>
                                        Press Forward Mail helps missionaries and their families
                                        spend less time managing email lists and more time focusing
                                        on what matters most.
                                    </p>
                                </div>

                                <div className="how-it-works">
                                    <h2>How It Works</h2>
                                    <div className="steps-grid">
                                        <div className="step-item">
                                            <div className="step-number">1</div>
                                            <h4>Create Account</h4>
                                            <p>Sign up and add your missionary's information</p>
                                        </div>

                                        <div className="step-item">
                                            <div className="step-number">2</div>
                                            <h4>Share Your Link</h4>
                                            <p>
                                                Use our QR code and link to let family and friends
                                                subscribe
                                            </p>
                                        </div>

                                        <div className="step-item">
                                            <div className="step-number">3</div>
                                            <h4>Send Updates</h4>
                                            <p>Email your updates to our forwarding address</p>
                                        </div>

                                        <div className="step-item">
                                            <div className="step-number">4</div>
                                            <h4>Automatic Delivery</h4>
                                            <p>
                                                We automatically forward emails to all subscribers
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div className="cta-section">
                                    <h3>Ready to get started?</h3>
                                    <p>
                                        Join families worldwide who trust Press Forward Mail to stay
                                        connected.
                                    </p>
                                    <Button
                                        className="cta-button"
                                        size="lg"
                                        onClick={() => navigate('/login')}
                                    >
                                        Get Started Today
                                    </Button>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </div>
    );
}

export default About;
